"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.captureFeedback = captureFeedback;

var _currentScopes = require("./currentScopes.js");

var _object = require("./utils-hoist/object.js");

/**
 * Send user feedback to Sentry.
 */
function captureFeedback(params, hint = {}, scope = (0, _currentScopes.getCurrentScope)()) {
  const message = params.message,
        name = params.name,
        email = params.email,
        url = params.url,
        source = params.source,
        associatedEventId = params.associatedEventId,
        tags = params.tags;
  const feedbackEvent = {
    contexts: {
      feedback: (0, _object.dropUndefinedKeys)({
        contact_email: email,
        name,
        message,
        url,
        source,
        associated_event_id: associatedEventId
      })
    },
    type: 'feedback',
    level: 'info',
    tags
  };
  const client = scope && scope.getClient() || (0, _currentScopes.getClient)();

  if (client) {
    client.emit('beforeSendFeedback', feedbackEvent, hint);
  }

  const eventId = scope.captureEvent(feedbackEvent, hint);
  return eventId;
}